export default {
  entities: {},
  tilesIds: [],
  tilesTypesIds: [],
  tilesGroupsIds: [],
  defaultTilesGroupId: null
};
